/* tpl-mat-pair-builder.js — "Two on a wall" (2026-10-29).
   Drives sections/tpl-mat-pair-builder.liquid:
     - the first piece mirrors the buy box (Size / Mat / Framing)
     - the snap row swaps the second piece; its mat defaults to a different
       mat from the first and skips sold-out variants
     - the price line shows both prices, the pair saving and the total,
       printed in the shop money format inside .money spans (Bucks converts)
     - "Add the pair" posts both variants to /cart/add.js and sends the same
       cart events as tpl-cart-event-bridge.js, so the drawer opens with both.
   Does nothing until the band is near the viewport. No timers run at rest. */
(function () {
  'use strict';

  var COMPLEMENT = {
    Silver: ['Marine', 'Burgundy', 'Silver'],
    Marine: ['Burgundy', 'Silver', 'Marine'],
    Burgundy: ['Marine', 'Silver', 'Burgundy']
  };
  var MATS = ['Silver', 'Marine', 'Burgundy'];
  var SWAP_OUT_MS = 140;
  var ERR_GENERIC = 'Could not add the pair just now. Please try again.';
  var ERR_NETWORK = 'No connection. Check your signal and try again.';

  var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ── helpers ─────────────────────────────────────────── */
  function parseJSON(text) {
    try {
      return JSON.parse(text);
    } catch (err) {
      return null;
    }
  }

  function key(size, mat, frame) {
    return size + '|' + mat + '|' + frame;
  }

  function sideOf(pos) {
    var p = String(pos || '').toLowerCase();
    if (p.indexOf('l') !== -1) return -1;
    if (p.indexOf('r') !== -1) return 1;
    return 0;
  }

  function sizeNum(size) {
    var n = parseFloat(String(size || ''));
    return isFinite(n) ? n : 10;
  }

  /* Shopify's {{amount_no_decimals}} etc., from the shop's own format string.
     Tags in the format are dropped; the caller wraps the result in .money. */
  function groupDigits(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents, fmt) {
    var template = String(fmt || '₹ {{amount_no_decimals}}').replace(/<[^>]*>/g, '').replace(/&lt;.*?&gt;/g, '').replace(/&amp;/g, '&').trim();
    var value = Math.round(Number(cents) || 0);
    return template.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, kind) {
      var whole = Math.round(value / 100);
      var exact = (value / 100).toFixed(2).split('.');
      switch (kind) {
        case 'amount_no_decimals_with_comma_separator':
          return groupDigits(whole, '.');
        case 'amount_with_comma_separator':
          return groupDigits(exact[0], '.') + ',' + exact[1];
        case 'amount':
          return groupDigits(exact[0], ',') + '.' + exact[1];
        default:
          return groupDigits(whole, ',');
      }
    });
  }

  function moneyHTML(cents, fmt) {
    var span = document.createElement('span');
    span.className = 'money';
    span.textContent = formatMoney(cents, fmt);
    return span;
  }

  function bucksReconvert() {
    try {
      if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') window.bucksCC.reConvert();
    } catch (err) {
      /* currency app absent: rupees stay */
    }
  }

  function track(name, payload) {
    if (typeof window.tplTrack === 'function') { try { window.tplTrack(name, payload); } catch (e) {} return; }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (err) {
      /* analytics must never block the cart */
    }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (err) {
      /* same */
    }
  }

  /* Buy box values. Scoped to the main variant picker first so a sticky bar
     copy further down the page never wins. */
  function buyBoxValue(names) {
    var scopes = [document.querySelector('variant-selects, variant-radios'), document];
    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope) continue;
      for (var n = 0; n < names.length; n++) {
        var sel = scope.querySelector('select[name="options[' + names[n] + ']"]');
        if (sel && sel.value) return sel.value;
        var radio = scope.querySelector('input[name="options[' + names[n] + ']"]:checked');
        if (radio) return radio.value;
      }
    }
    return null;
  }

  /* ── one band ────────────────────────────────────────── */
  function PairBuilder(root) {
    var dataEl = root.querySelector('[data-pb-data]');
    var data = dataEl ? parseJSON(dataEl.textContent) : null;
    if (!data || !data.me || !data.list || !data.list.length) {
      root.hidden = true;
      return;
    }
    this.root = root;
    this.data = data;
    this.byHandle = {};
    for (var i = 0; i < data.list.length; i++) this.byHandle[data.list[i].h] = data.list[i];

    this.wall = root.querySelector('[data-pb-wall]');
    this.slotA = root.querySelector('[data-pb-slot="a"]');
    this.slotB = root.querySelector('[data-pb-slot="b"]');
    this.addBtn = root.querySelector('[data-pb-add]');
    this.msg = root.querySelector('[data-pb-msg]');
    this.tiles = Array.prototype.slice.call(root.querySelectorAll('[data-pb-pick]'));
    this.chips = Array.prototype.slice.call(root.querySelectorAll('[data-pb-mat]'));

    var initA = data.init || {};
    this.bHandle = this.byHandle[initA.b] ? initA.b : data.list[0].h;
    this.userMat = null;
    this.bMat = initA.m || null;
    this.a = null;
    this.busy = false;
    this.swapToken = 0;
    this.offer = !!data.offer && !this.offerExpired();

    this.bind();
    this.render(false);
  }

  /* data.end: Unix seconds (shared end, snippets/tpl-mat-pair-offer.liquid)
     or YYYYMMDD (the section's optional override). */
  PairBuilder.prototype.offerExpired = function () {
    var end = Number(this.data.end) || 0;
    if (!end) return false;
    if (end > 1e9) return Date.now() > end * 1000;
    var d = new Date();
    var today = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    return today > end;
  };

  PairBuilder.prototype.readA = function () {
    var prev = this.a || {};
    return {
      size: buyBoxValue(['Size']) || prev.size || '',
      mat: buyBoxValue(['Mat']) || prev.mat || '',
      frame: buyBoxValue(['Framing', 'Frame']) || prev.frame || ''
    };
  };

  PairBuilder.prototype.imgUrl = function (rel, width) {
    if (!rel) return '';
    var base = /^(https?:)?\/\//.test(rel) ? '' : this.data.base || '';
    var sep = rel.indexOf('?') === -1 ? '?' : '&';
    return base + rel + sep + 'width=' + width;
  };

  PairBuilder.prototype.variant = function (prod, size, mat, frame) {
    var v = prod && prod.v ? prod.v[key(size, mat, frame)] : null;
    return v ? { id: v[0], price: v[1], available: v[2] === 1 } : null;
  };

  PairBuilder.prototype.resolveMat = function (prod) {
    var a = this.a;
    var order = (COMPLEMENT[a.mat] || MATS).slice();
    if (this.userMat) order.unshift(this.userMat);
    for (var i = 0; i < order.length; i++) {
      var v = this.variant(prod, a.size, order[i], a.frame);
      if (v && v.available) return order[i];
    }
    return null;
  };

  /* ── drawing ─────────────────────────────────────────── */
  PairBuilder.prototype.paintPiece = function (slot, prod, mat, frame) {
    var piece = slot.querySelector('.tpl-piece');
    var img = piece && piece.querySelector('img');
    if (!piece || !img || !prod) return;
    var rel = prod.im[mat + '|' + frame] || prod.im[Object.keys(prod.im)[0]];
    var url = this.imgUrl(rel, 720);
    if (img.getAttribute('src') !== url) {
      img.removeAttribute('srcset');
      img.src = url;
    }
    piece.classList.toggle('tpl-piece--cropped', !!prod.c);
    img.setAttribute('style', prod.c || '');
    img.alt = prod.t;
    if (prod.ar) img.setAttribute('height', String(Math.round(360 / prod.ar)));
  };

  PairBuilder.prototype.paintFirst = function () {
    var piece = this.slotA && this.slotA.querySelector('[data-piece-imgs]');
    var img = piece && piece.querySelector('img');
    if (!img) return;
    var map = parseJSON(piece.getAttribute('data-piece-imgs')) || {};
    var url = map[this.a.mat + '|' + this.a.frame];
    if (url && img.getAttribute('src') !== url) {
      img.removeAttribute('srcset');
      img.src = url;
    }
  };

  /* Short fade-and-settle on the second piece. The new picture is fetched
     before the old one leaves so the wall never shows an empty frame. */
  PairBuilder.prototype.swapSecond = function (prod, mat, frame) {
    var self = this;
    var token = ++this.swapToken;
    if (calm.matches) {
      this.paintPiece(this.slotB, prod, mat, frame);
      return;
    }
    var rel = prod.im[mat + '|' + frame] || prod.im[Object.keys(prod.im)[0]];
    var pre = new Image();
    var done = false;
    function go() {
      if (done || token !== self.swapToken) return;
      done = true;
      self.slotB.classList.add('is-out');
      window.setTimeout(function () {
        if (token !== self.swapToken) return;
        self.paintPiece(self.slotB, prod, mat, frame);
        window.requestAnimationFrame(function () {
          self.slotB.classList.remove('is-out');
        });
      }, SWAP_OUT_MS);
    }
    pre.onload = go;
    pre.onerror = go;
    window.setTimeout(go, 500);
    pre.src = this.imgUrl(rel, 720);
  };

  PairBuilder.prototype.setText = function (selector, text) {
    this.root.querySelectorAll(selector).forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  };

  PairBuilder.prototype.setMoney = function (selector, cents) {
    var fmt = this.data.fmt;
    this.root.querySelectorAll(selector).forEach(function (el) {
      el.replaceChildren(moneyHTML(cents, fmt));
    });
  };

  PairBuilder.prototype.render = function (animate) {
    var data = this.data;
    var prevB = this.renderedB;
    var prevMat = this.renderedMat;
    this.a = this.readA();
    var a = this.a;
    var prod = this.byHandle[this.bHandle];
    this.bMat = this.resolveMat(prod);
    var showMat = this.bMat || (COMPLEMENT[a.mat] || MATS)[0];

    /* wall: first piece, size, which side each hangs */
    this.paintFirst();
    if (prevB !== this.bHandle || prevMat !== showMat || this.renderedFrame !== a.frame) {
      if (animate && prevB !== this.bHandle) this.swapSecond(prod, showMat, a.frame);
      else this.paintPiece(this.slotB, prod, showMat, a.frame);
    }
    this.renderedB = this.bHandle;
    this.renderedMat = showMat;
    this.renderedFrame = a.frame;

    var n = sizeNum(a.size);
    this.wall.setAttribute('data-pb-size', String(n));
    this.wall.toggleAttribute('data-pb-b-first', sideOf(prod.wp) > sideOf(data.me.wp));
    this.root.classList.toggle('is-sold-out', !this.bMat);

    this.setText('[data-pb-a-name]', data.me.t);
    this.setText('[data-pb-b-name]', prod.t);
    this.setText('[data-pb-cap-names]', data.me.t + ' + ' + prod.t);
    this.setText('[data-pb-cap-size]', n + ' in each');
    this.setText('[data-pb-follow]', a.frame + ' frame, ' + n + ' in');

    /* picker + mat chips */
    var self = this;
    this.tiles.forEach(function (tile) {
      var h = tile.getAttribute('data-pb-pick');
      var on = h === self.bHandle;
      tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      tile.classList.toggle('is-on', on);
      var p = self.byHandle[h];
      var any = false;
      for (var i = 0; p && i < MATS.length; i++) {
        var v = self.variant(p, a.size, MATS[i], a.frame);
        if (v && v.available) any = true;
      }
      tile.classList.toggle('is-out', !any);
    });
    this.chips.forEach(function (chip) {
      var m = chip.getAttribute('data-pb-mat');
      var v = self.variant(prod, a.size, m, a.frame);
      var ok = !!(v && v.available);
      chip.disabled = !ok;
      chip.setAttribute('aria-pressed', m === self.bMat ? 'true' : 'false');
      chip.setAttribute('aria-label', m + (ok ? '' : ', sold out'));
      self.paintChip(chip, prod, m, a.frame);
    });

    /* prices */
    var va = this.variant(data.me, a.size, a.mat, a.frame);
    var vb = this.bMat ? this.variant(prod, a.size, this.bMat, a.frame) : null;
    this.current = va && vb ? { a: va, b: vb } : null;
    if (va) this.setMoney('[data-pb-a-price]', va.price);
    if (vb) this.setMoney('[data-pb-b-price]', vb.price);
    if (va && vb) {
      var sum = va.price + vb.price;
      /* flat amount off the pair, cents, read from the markup (data.off) */
      var off = Math.max(0, Number(data.off) || 0);
      var saving = this.offer ? Math.min(off, sum) : 0;
      this.setMoney('[data-pb-total]', sum - saving);
      this.setMoney('[data-pb-was]', sum);
      this.setMoney('[data-pb-save]', saving);
    }
    this.root.querySelectorAll('[data-pb-was], [data-pb-save-row]').forEach(function (el) {
      el.hidden = !self.offer;
    });

    /* button state + reason, in plain words */
    var reason = '';
    if (!va || !va.available) reason = 'Your first piece is sold out in this choice. Try another mat or frame above.';
    else if (!vb) reason = prod.t + ' is sold out in this size and frame. Pick another piece.';
    if (!this.busy) {
      this.addBtn.disabled = !!reason;
      this.addBtn.textContent = this.addBtn.getAttribute('data-label') || 'Add the pair';
    }
    if (this.msg && this.msgKind !== 'error' && this.msg.textContent !== reason) this.msg.textContent = reason;

    this.paintThumbs();
    bucksReconvert();
  };

  /* Mat chips carry the buy box's mat squares (owner 2026-11-03): the second piece
     in that mat and the current frame, cropped to its frame like snippets/tpl-mat-piece. */
  PairBuilder.prototype.paintChip = function (chip, prod, mat, frame) {
    var dot = chip.querySelector('.tpl-pb__dot');
    var rel = prod && prod.im ? prod.im[mat + '|' + frame] : '';
    if (!dot || !rel) return;
    var img = dot.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      dot.appendChild(img);
      dot.classList.add('tpl-pb__dot--sq');
    }
    var url = this.imgUrl(rel, 160);
    if (img.getAttribute('src') !== url) img.src = url;
    img.setAttribute('style', prod.c || '');
    dot.classList.toggle('is-cropped', !!prod.c);
  };

  /* Picker thumbnails follow the frame on the wall, each in the mat it would
     hang in: the mat chosen below when that piece has it (owner 2026-11-01), else
     its complementary mat. Repaints when the first piece or the chosen mat moves. */
  PairBuilder.prototype.paintThumbs = function () {
    var a = this.a;
    var stamp = a.size + '|' + a.mat + '|' + a.frame + '|' + (this.userMat || '');
    if (this.thumbStamp === stamp) return;
    var first = this.thumbStamp === undefined;
    this.thumbStamp = stamp;
    if (first) return; /* server already drew them for the load state */
    var self = this;
    this.tiles.forEach(function (tile) {
      var p = self.byHandle[tile.getAttribute('data-pb-pick')];
      var img = tile.querySelector('img');
      if (!p || !img) return;
      var m = self.resolveMat(p) || (COMPLEMENT[a.mat] || MATS)[0];
      var rel = p.im[m + '|' + a.frame];
      if (!rel) return;
      var url = self.imgUrl(rel, 240);
      if (img.getAttribute('src') !== url) img.src = url;
    });
  };

  /* ── events ──────────────────────────────────────────── */
  PairBuilder.prototype.bind = function () {
    var self = this;
    var queued = false;
    function later() {
      if (queued) return;
      queued = true;
      window.setTimeout(function () {
        queued = false;
        self.clearError();
        self.render(false);
      }, 60);
    }
    this.later = later;

    this.root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var tile = t.closest('[data-pb-pick]');
      if (tile) {
        var h = tile.getAttribute('data-pb-pick');
        if (h === self.bHandle || !self.byHandle[h]) return;
        self.bHandle = h;
        self.clearError();
        self.render(true);
        return;
      }
      var chip = t.closest('[data-pb-mat]');
      if (chip && !chip.disabled) {
        self.userMat = chip.getAttribute('data-pb-mat');
        self.clearError();
        self.render(false);
        return;
      }
      if (t.closest('[data-pb-add]')) self.add();
    });

    /* Buy box: tiles mirror into hidden selects and fire a bubbling change;
       Dawn also publishes variantChange. Either one re-reads the options. */
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (self.root.contains(e.target)) return;
      if (e.target.closest('variant-selects, variant-radios, form[action*="/cart/add"], .tpl-mat-swatches')) later();
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest || self.root.contains(e.target)) return;
      if (e.target.closest('.tpl-mat-swatch, [data-frame-dot], variant-selects label')) later();
    });
    try {
      /* Dawn declares these as top-level const/function, not window props */
      /* global subscribe, PUB_SUB_EVENTS */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, later);
      }
    } catch (err) {
      /* Dawn pub/sub absent: the change listener covers it */
    }
    /* Bucks may wake after the first paint; ask it once more on load. */
    window.addEventListener('load', bucksReconvert, { once: true });
  };

  PairBuilder.prototype.clearError = function () {
    if (this.msgKind === 'error') {
      this.msgKind = null;
      if (this.msg) this.msg.textContent = '';
    }
  };

  PairBuilder.prototype.fail = function (text) {
    this.msgKind = 'error';
    if (this.msg) this.msg.textContent = text;
  };

  PairBuilder.prototype.add = function () {
    var self = this;
    this.a = this.readA();
    this.render(false);
    var pick = this.current;
    if (this.busy || !pick || !pick.a.available || !pick.b.available) return;
    var btn = this.addBtn;
    var label = btn.getAttribute('data-label') || 'Add the pair';
    this.busy = true;
    this.clearError();
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding...';
    var body = { items: [{ id: pick.a.id, quantity: 1 }, { id: pick.b.id, quantity: 1 }] };
    var prod = this.byHandle[this.bHandle];

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(
        function (res) {
          var type = (res.headers.get('content-type') || '').toLowerCase();
          /* Shopify answers as JSON or text/javascript; anything else is a challenge page */
          if (type.indexOf('json') === -1 && type.indexOf('javascript') === -1) throw new Error(ERR_GENERIC);
          return res.json().then(function (json) {
            if (!res.ok) {
              var text = json && (json.description || json.message);
              /* Shopify's wording for a variant that is gone (unpublished, deleted) */
              if (text && /cannot find variant/i.test(text)) text = 'This piece is not available right now. Pick another.';
              throw new Error(
                res.status === 422 ? text || 'One of these just sold out. Pick another mat or piece.' : ERR_GENERIC
              );
            }
            return json;
          });
        },
        function () {
          throw new Error(ERR_NETWORK);
        }
      )
      .then(function (json) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
        var first = json && json.items && json.items.length ? json.items[0] : json;
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: first, trigger: btn } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') {
              document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { count: cart.item_count } }));
            }
          })
          .catch(function () {
            /* drawer refresh is the fallback */
          });
        var announcer = document.getElementById('tpl-live-announcer');
        if (announcer) announcer.textContent = 'Added ' + self.data.me.t + ' and ' + prod.t + ' to cart.';
        track('tpl_pair_add', {
          first: self.data.me.h,
          second: prod.h,
          variants: [pick.a.id, pick.b.id],
          value: (pick.a.price + pick.b.price) / 100
        });
        btn.textContent = 'Added';
        window.setTimeout(function () {
          self.busy = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
          self.render(false);
        }, 1600);
      })
      .catch(function (err) {
        self.busy = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        btn.disabled = false;
        self.fail((err && err.message) || ERR_GENERIC);
      });
  };

  /* ── boot: wait until the band is close ─────────────── */
  function start(root) {
    if (root.dataset.pbReady) return;
    root.dataset.pbReady = '1';
    root.tplPairBuilder = new PairBuilder(root);
  }

  function watch(root) {
    if (!('IntersectionObserver' in window)) {
      start(root);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            start(root);
            return;
          }
        }
      },
      { rootMargin: '400px 0px' }
    );
    io.observe(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tpl-pair-builder]').forEach(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) boot(e.target);
  });

  /* exposed for the fixture tests only */
  window.tplPairBuilderFormat = formatMoney;
})();
